import React from 'react';
import './index.css';
import 'antd/dist/antd.css';

import PermanentMeetingLinkRecaptcha from './Components/PermanentMeetingLinkRecaptcha';
import MeetingSchedulerPage from './Components/MeetingSchedulerPage'
import Fallback from './Components/Fallback';
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";

const App =  () => {
    return <div>
        <Router>
            <Switch>
                <Route path="/dm/:meetingLink+" name="Set Direct Meeting">
                    <PermanentMeetingLinkRecaptcha/>
                </Route>

                <Route path="/set-meeting/:token" name="Set Meeting">
                    <MeetingSchedulerPage/>
                </Route>

                <Route exact path="/">
                    <Fallback/>
                </Route>
            </Switch>
        </Router>
    </div>
}

export default App;